<template>

  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <Box theme="box-primary" title="Tìm kiếm">
          <div slot="custombtn">
            <button id="popover-config-search" class="btn btn-box-tool">
              <i class="fa fa-cog" aria-hidden="true"></i>
            </button>
            <b-popover :show.sync="showConfigSearch" target="popover-config-search" title="Cấu hình hiển thị" triggers="hover">
              <b-table :items="configSearchItems" responsive :fields="configFields">
                <template v-slot:cell(key)="data">
                  <b-form-checkbox v-model="data.item.show"
                                   @change="toggleColumnSearchForm($event, data.item.key)"></b-form-checkbox>
                </template>
                <template v-slot:cell(label)="data">
                  {{ data.item.label }}
                </template>
              </b-table>
            </b-popover>
          </div>
          <div slot="content">
            <div v-show="isShowSearch('from_date')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Ngày thanh toán từ ngày</label>
              <date-picker v-model="filterData.from_date" valueType="format"></date-picker>
            </div>
            <div v-show="isShowSearch('to_date')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Đến ngày</label>
              <date-picker v-model="filterData.to_date" valueType="format"></date-picker>
            </div>
            <div v-show="isShowSearch('type')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Loại thanh toán</label>
              <multiselect v-model="filterData.type" :options="types" :multiple="false"
                           :close-on-select="true"
                           placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
            </div>
<!--            <div v-show="isShowSearch('debt_status')" class="form-group col-md-3 col-sm-6 col-xs-12">-->
<!--              <label>Trạng thái nợ</label>-->
<!--              <multiselect v-model="filterData.debt_status" :options="debt_status_list" :multiple="false"-->
<!--                           :close-on-select="true"-->
<!--                           placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>-->
<!--            </div>-->
            <div v-show="isShowSearch('status')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Trạng thái đơn hàng</label>
              <div class="d-flex">
                <multiselect v-model="filterData.status" :options="statusList" :multiple="true" :close-on-select="false"
                             :limit="1"
                             @select="onSelectStatus($event, filterData.status)"
                             @remove="onRemoveStatus($event, filterData.status)"
                             placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
                <multiselect v-model="filterData.statusDetail" :limit="1" :options="statusDetailList" :multiple="true"
                             :close-on-select="false" placeholder="Vui lòng chọn" label="text"
                             track-by="value"></multiselect>
              </div>
            </div>
            <div v-show="isShowSearch('data_source')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Nguồn đơn</label>
              <div class="d-flex">
                <multiselect v-model="filterData.data_source" :options="data_source" :multiple="true"
                             :close-on-select="false" :limit="1"
                             @select="onSelectSource($event, filterData.status)"
                             @remove="onRemoveSource($event, filterData.status)"
                             placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
                <multiselect v-model="filterData.data_channel" :options="data_channel" :multiple="true"
                             :close-on-select="false" :limit="1"
                             placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
              </div>
            </div>
            <div v-show="isShowSearch('payment_status')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Trạng thái hóa đơn</label>
              <div class="d-flex">
                <multiselect v-model="filterData.payment_status" :options="paymentStatus" :multiple="true"
                             :close-on-select="false" :limit="1"
                             placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
              </div>
            </div>
            <div v-show="isShowSearch('pics')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Nhân viên chăm sóc</label>
              <multiselect v-model="filterData.pics" id="ajax" label="name" track-by="code"
                           placeholder="Nhập để tìm kiếm người dùng"
                           open-direction="bottom" :options="groupUser" :multiple="true" :searchable="true"
                           select-group-label="Chọn tất cả" deselect-group-label="Bỏ chọn tất cả"
                           group-label="label" group-values="users" :group-select="true"
                           :loading="loadingUser" :internal-search="true" :clear-on-select="false"
                           :close-on-select="false" :options-limit="300" :limit="2" :max-height="600"
                           :show-no-results="false" :hide-selected="false">
              </multiselect>
            </div>
            <div v-show="isShowSearch('products')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Sản phẩm</label>
              <multiselect id="ajax" v-model="filterData.products" :clear-on-select="false"
                           :close-on-select="false" :hide-selected="false" :internal-search="true" :limit="2"
                           :loading="loadingProduct" :max-height="600" :multiple="true"
                           :options="groupProduct" :options-limit="300" :searchable="true" :show-no-results="false"
                           select-group-label="Chọn tất cả" deselect-group-label="Bỏ chọn tất cả"
                           group-label="label" group-values="products" :group-select="true"
                           label="name" open-direction="bottom"
                           placeholder="Nhập để tìm kiếm sản phẩm" track-by="code">
              </multiselect>
            </div>
            <div v-show="isShowSearch('deleted_products')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Sản phẩm đã xóa</label>
              <multiselect id="ajax" v-model="filterData.deletedProducts" :clear-on-select="false"
                           :close-on-select="false" :hide-selected="false" :internal-search="true" :limit="2"
                           :loading="loadingDeletedProduct" :max-height="600" :multiple="true"
                           :options="deletedGroupProduct" :options-limit="300" :searchable="true" :show-no-results="false"
                           select-group-label="Chọn tất cả" deselect-group-label="Bỏ chọn tất cả"
                           group-label="label" group-values="products" :group-select="true"
                           label="name" open-direction="bottom"
                           placeholder="Nhập để tìm kiếm sản phẩm" track-by="code">
              </multiselect>
            </div>
            <div v-show="isShowSearch('phone')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Số điện thoại</label>
              <input type="text" class="form-control" v-model="filterData.phone"
                     placeholder="Nhập tên số điện thoại..."/>
            </div>
            <div v-show="isShowSearch('customer_name')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Tên khách hàng</label>
              <input type="text" class="form-control" v-model="filterData.customer_name"
                     placeholder="Nhập tên khách hàng..."/>
            </div>
            <div v-show="isShowSearch('charge_date')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Ngày tính phí</label>
              <date-picker v-model="filterData.charge_date" range valueType="format" type="month" lang="vi"></date-picker>
            </div>
          </div>
          <div slot="footer">
            <div class="d-flex justify-content-end align-items-center">
              <b-button variant="success" @click="search" style="margin-top: 25px">
                <span class="glyphicon glyphicon-search" aria-hidden="true"></span>Tìm kiếm
              </b-button>
            </div>
          </div>
        </Box>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <Box theme="box-primary" title="Danh sách thanh toán">
          <div slot="content">
            <b-table    bordered outlined hover responsive :busy="loading" :fields="fields" :items="items"
                     show-empty
                     @row-dblclicked="onDoubleClicked">
              <template #table-busy>
                <div class="text-center my-2 mt-5 mb-5">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Đang tải...</strong>
                </div>
              </template>

              <template #empty="scope">
                <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
              </template>

              <template v-slot:cell(type)="data">
                {{ data.item.payment.type === 'NEW_BUY' ? 'Thanh toán 1 lần' : 'Thanh toán định kỳ' }}
              </template>
              <template v-slot:cell(customer)="data">
                <span class="tel" @click="callPhone(data.item.payment.order.customer.phone)">{{data.item.payment.order.customer.phone}}</span>
                <br>
                <span>{{data.item.payment.order.customer_name}}</span>
              </template>
              <template v-slot:cell(pic_name)="data">
                <span>{{data.item.payment.order.pic_name}}</span>
              </template>
              <template v-slot:cell(status)="data">
                {{data.item.payment.status === 'WAITING_APPROVAL' ? 'Chờ xác nhận' : data.item.payment.status === 'APPROVED' ? 'Đã duyệt' : data.item.payment.status === 'DISAPPROVED' ? 'Không duyệt' : data.item.payment.status === 'DELETED' ? 'Đã hủy bởi sale' : 'Đã hủy bởi kế toán'}}
              </template>
              <template v-slot:cell(value)="data">
                <span v-if="!data.item.editMode">{{ data.item.payment.value | format_currency }}</span>
                <input v-else type="number" class="form-control" v-model.number="data.item.payment.value"/>
              </template>
<!--              <template v-slot:cell(debt_status)="data">-->
<!--                {{ getDebtStatusString(data.item.payment.order.debt_status) }}-->
<!--              </template>-->
              <template v-slot:cell(contract_value)="data">
                <span>{{ (data.item.payment.order.amount + data.item.payment.order.annual_amount) | format_currency }}</span>
              </template>
              <template v-slot:cell(current_value)="data">
                <span>{{data.item.value | format_currency}}</span>
              </template>
              <template v-slot:cell(product_value)="data">
                <span>{{data.item.order_detail.total_payment_amount | format_currency}}</span>
              </template>
              <template v-slot:cell(payment_id)="data">
                <span>{{data.item.payment.id}}</span>
              </template>
              <template v-slot:cell(created_at)="data">
                <span>{{data.item.payment.created_at | format_date_time}}</span>
              </template>

              <template v-slot:cell(actions)="data">
                <b-button variant="success" v-b-tooltip.hover title="Duyệt"
                          @click="showApproveModal(data.item.payment)" :disabled="data.item.payment.status !== 'WAITING_APPROVAL' || !isEditable"><i class="fa fa-check-circle" aria-hidden="true"/></b-button>
                <b-button variant="warning" v-b-tooltip.hover title="Không duyệt"
                          @click="showDispproveModal(data.item.payment)" :disabled="data.item.payment.status !== 'WAITING_APPROVAL' || !isEditable"><i class="fa fa-ban" aria-hidden="true"/></b-button>
                <b-button variant="danger" v-b-tooltip.hover title="Hủy duyệt"
                          @click="showCancelApprovedModal(data.item.payment)" :disabled="data.item.payment.status !== 'APPROVED' || !isEditable"><i class="fa fa-trash"/></b-button>
              </template>

            </b-table>
          </div>
          <div slot="footer">
            <div><strong>Tổng số hóa đơn: </strong><label>{{ totalRow }}</label></div>
            <div><strong>Tổng giá trị: </strong><label>{{ totalValue | format_currency }}</label></div>
          </div>
        </Box>
      </div>

      <div class="col-md-12 col-sm-12 col-xs-12 d-flex align-items-center justify-content-between">
        <div class="page-size-container">
          <span>Hiển thị</span>
          <b-form-select
            id="pageSize"
            v-model="pageSize"
            :options="pageSizes"
            required
          ></b-form-select>
          <span>  dòng</span>
        </div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRow"
          :per-page="pageSize"
          aria-controls="my-table"
        ></b-pagination>
      </div>
    </section>

    <b-modal size='xl' id="orderDetailModal" hide-footer title="Chi tiết đơn hàng" @hide="() => this.filter()"
             header-class="crm-modal">
      <div class="col-md-12 col-sm-12 col-xs-12 mb-5">
        <OrderAdd :disablePic="true" :orderId="selectedId" :hide-modal="hideModal" :disabled-save="true"></OrderAdd>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <OrderDetailList :updatingOrderId="selectedId" type="NEW_BUY" :disabled-save="true"></OrderDetailList>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <OrderDetailList :updatingOrderId="selectedId" type="ANNUAL_BUY" :disabled-save="true"></OrderDetailList>
      </div>
    </b-modal>

    <b-modal size='sm' id="approveModal" hide-footer title="Duyệt thanh toán" @hide="hideApproveModal"
             header-class="crm-modal">
      <div class="col-md-12 col-sm-12 col-xs-12 mb-5">
        <label>Ghi chú:</label>
        <textarea
          class="form-control"
          id="textarea1"
          v-model="approveText"
          rows="3"
          style="height: 71px!important;"
        ></textarea>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="pull-right mt-3">
          <b-button variant="warning" class="w-150px" @click="approve">Duyệt</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal size='sm' id="cancelApprovedModal" hide-footer title="Hủy duyệt thanh toán" @hide="hideCancelApprovedModal"
             header-class="crm-modal">
      <div class="col-md-12 col-sm-12 col-xs-12 mb-5">
        <label>Ghi chú:</label>
        <textarea
          class="form-control"
          id="textarea1"
          v-model="cancelApprovedText"
          rows="3"
          style="height: 71px!important;"
        ></textarea>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="pull-right mt-3">
          <b-button variant="warning" class="w-150px" @click="cancelApproved">Hủy Duyệt</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal size='sm' id="disapproveModal" hide-footer title="Huỷ duyệt thanh toán" @hide="hideApproveModal"
             header-class="crm-modal">
      <div class="col-md-12 col-sm-12 col-xs-12 mb-5">
        <label>Ghi chú:</label>
        <textarea
          class="form-control"
          id="textarea1"
          v-model="disapproveText"
          rows="3"
          style="height: 71px!important;"
        ></textarea>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="pull-right mt-3">
          <b-button variant="danger" class="w-150px" @click="disapprove">Không duyệt</b-button>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import Box from '../../components/Box'
import Utils from '../../common/utils'
import PaymentApi from '../../api/payment'
import moment from 'moment'
import {mapActions, mapGetters} from 'vuex'
import {
  DEBT_STATUS_LIST,
  LOCAL_STORAGE_KEY,
  PERMISSION_KEY,
  PAYMENT_STATUS_LIST,
  MAX_PRODUCT_NUMBER,
  MAX_SALE_USER_NUMBER
} from '../../common/constant'
import UserApi from '../../api/user'
import DatePicker from 'vue2-datepicker'
import Multiselect from '../../lib/vue-multiple-select/Multiselect'
import {debounce} from 'lodash'
import OrderAdd from '../order_management/OrderAddOrEdit'
import OrderDetailList from '../order_management/OrderDetailList'
import DataStatusAPI from '../../api/dataStatus'
import DataSubStatusAPI from '../../api/dataSubStatus'
import DataSourceAPI from '../../api/dataSource'
import DataChannelAPI from '../../api/dataChannel'
import * as Constants from '../../common/constant'
import ProductApi from '../../api/product'

export default {
  name: 'AccountingDetailList',
  components: {
    Box,
    DatePicker,
    Multiselect,
    OrderAdd,
    OrderDetailList,
  },
  props: {
    orderId: {
      type: Number,
      required: false,
    }
  },
  data () {
    return {
      company: null,
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      totalValue: 0,
      pageSizes: [
        {text: 1000, value: 1000},
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      types: [
        {text: 'Thanh toán mua 1 lần', value: 'NEW_BUY'},
        {text: 'Thanh toán định kỳ', value: 'ANNUAL_BUY'}
      ],
      debt_status_list: Constants.DEBT_STATUS_LIST,
      fields: [
        {
          key: 'id',
          label: 'STT',
          show: true
        }, {
          key: 'customer',
          label: 'SĐT/Mã KH',
          show: true
        },
        {
          key: 'type',
          label: 'Thông tin thanh toán',
          show: true
        }, {
          key: 'payment_id',
          label: 'Mã hóa đơn',
          show: true
        }, {
          key: 'order_detail.id',
          label: 'Mã sản phẩm',
          show: true
        }, {
          key: 'value',
          label: 'Giá trị hóa đơn',
          show: true
        }, {
          key: 'product_value',
          label: 'Giá tiền sản phẩm',
          show: true
        }, {
          key: 'current_value',
          label: 'Giá trị thanh toán lần này',
          show: true
        }, {
          key: 'contract_value',
          label: 'Giá tiền hợp đồng/đơn hàng',
          show: false
        }, {
          key: 'status',
          label: 'Trạng thái',
          show: true
        }, {
          key: 'pic_name',
          label: 'Nhân viên chăm sóc',
          show: true
        }, {
          key: 'payment.invoice_no',
          label: 'Mã chứng từ',
          show: true
        }, {
          key: 'payment.sale_note',
          label: 'Ghi chú của sale',
          show: true
        }, {
          key: 'payment.accountant_note',
          label: 'Ghi chú của kế toán',
          show: true
        }, {
          key: 'order_detail.payment_date',
          label: 'Ngày thanh toán',
          show: true
        }, {
          key: 'created_at',
          label: 'Thời gian tạo',
          show: true
        }, {
          key: 'actions',
          label: 'Duyệt',
          thStyle: 'width: 130px',
          class: 'actions-cell',
          show: true
        }
      ],
      items: [],
      users: [],
      groupUser: [],
      loadingUser: false,
      products: [],
      groupProduct: [],
      deletedProducts: [],
      deletedGroupProduct: [],
      loadingProduct: false,
      loadingDeletedProduct: false,
      debounceUser: null,
      filterData: {
        from_date: moment().startOf('month').format('yyyy-MM-DD'),
        to_date: moment().format('yyyy-MM-DD'),
        phone: '',
        customer_name: '',
        type: null,
        debt_status: null,
        payment_status: PAYMENT_STATUS_LIST,
        pics: [],
        status: [],
        statusDetail: [],
        data_source: [],
        data_channel: [],
        products: [],
        deletedProducts: [],
        charge_date: [null, null],
      },
      configSearchItems: [
        {
          key: 'from_date',
          label: 'Từ ngày',
          show: true
        }, {
          key: 'to_date',
          label: 'Đến ngày',
          show: true
        }, {
          key: 'charge_date',
          label: 'Ngày tính phí',
          show: true
        }, {
          key: 'phone',
          label: 'Số điện thoại',
          show: false
        }, {
          key: 'customer_name',
          label: 'Tên khách hàng',
          show: false
        }, {
          key: 'type',
          label: 'Loại thanh toán',
          show: true
        }, {
          key: 'pics',
          label: 'Nhân viên chăm sóc',
          show: false
        },
        {
          key: 'status',
          label: 'Trạng thái đơn hàng',
          show: false
        }, {
          key: 'data_source',
          label: 'Nguồn đơn',
          show: false
        }, {
          key: 'payment_status',
          label: 'Trạng thái hóa đơn',
          show: false
        }, {
          key: 'products',
          label: 'Sản phẩm',
          show: false
        }, {
          key: 'deleted_products',
          label: 'Sản phẩm đã xóa',
          show: false
        }
      ],
      showConfigSearch: false,
      configFields: [
        {
          key: 'key',
          label: 'Hiển thị'
        }, {
          key: 'label',
          label: 'Cột'
        }
      ],
      selectedId: null,
      selectedPaymentId: null,
      approveText: '',
      cancelApprovedText: '',
      disapproveText: '',
      statusList: [],
      statusDetailList: [],
      data_source: [],
      data_channel: [],
      paymentStatus: PAYMENT_STATUS_LIST,
      isEditable: true
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'editPermission'
    ])
  },
  mounted () {
    this.company = Utils.getCompanyByUserInfo(this.userInfo)
    this.initDataStatus()
    // this.filterProduct()
    this.filterDeletedProduct()
    this.isEditable = this.hasEditPermission()

    const orderListSearchItems = localStorage.getItem(LOCAL_STORAGE_KEY.ACCOUNTING_SEARCH_ITEMS)
    if (orderListSearchItems) {
      this.configSearchItems = JSON.parse(orderListSearchItems)
    }
  },
  created () {
    this.debounceUser = debounce(this.filterUser.bind(this), 500)
  },
  methods: {
    ...mapActions([
      'changePhoneNumber'
    ]),
    initDataStatus () {
      Promise.all([this.getDataStatus(), this.getDataSubStatus(), this.getDataSource(), this.getDataChannel()]).then(([dataStatus, dataSubStatus, dataSource, dataChannel]) => {
        this.statusList = dataStatus.map(item => {
          const subStatus = dataSubStatus.filter(subItem => subItem.data_status === item.id).map(subItem => {
            return {value: subItem.id, text: subItem.name, data_status: subItem.data_status}
          })
          return {value: item.id, text: item.name, details: subStatus}
        })

        this.data_source = dataSource.map(item => {
          const subList = dataChannel.filter(subItem => subItem.data_source === item.id).map(subItem => {
            return {value: subItem.id, text: subItem.name, data_source: subItem.data_source}
          })
          return {value: item.id, text: item.name, details: subList}
        })
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingUser = false
      })
    },
    async getDataStatus () {
      const response = await DataStatusAPI.filter(null, 0, 100)
      return response.data.data.records
    },
    async getDataSubStatus () {
      const response = await DataSubStatusAPI.filter(null, 0, 100)
      return response.data.data.records
    },
    async getDataSource () {
      const response = await DataSourceAPI.filter({name: null}, 0, 100)
      return response.data.data.records
    },
    async getDataChannel () {
      const response = await DataChannelAPI.filter({name: null}, 0, 100)
      return response.data.data.records
    },
    callPhone (phoneNumber) {
      this.changePhoneNumber({phoneNumber: phoneNumber})
      this.$bvModal.show('phone-call-modal')
    },
    isShowSearch (key) {
      const item = this.configSearchItems.find(item => item.key === key)
      if (item) {
        return item.show
      }
      return false
    },
    filterDeletedProduct () {
      this.loadingDeletedProduct = true
      ProductApi.filter({
        name: '',
        company_id: this.company.id,
        product_delete_type: 'DELETED'
      }, 0, MAX_PRODUCT_NUMBER).then(res => {
        this.deletedProducts = res.data.data.records.map(item => {
          return {'name': item.name, 'code': item.id}
        })
        // this.filterData.products = this.products
        this.deletedGroupProduct = [
          {
            label: 'Tất cả',
            products: this.deletedProducts
          }
        ]
        this.filterProduct()
        this.loadingDeletedProduct = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingDeletedProduct = false
      })
    },
    filterProduct () {
      this.loadingProduct = true
      ProductApi.filter({
        name: '',
        company_id: this.company.id
      }, 0, MAX_PRODUCT_NUMBER).then(res => {
        this.products = res.data.data.records.map(item => {
          return {'name': item.name, 'code': item.id}
        })
        this.filterData.products = this.products
        this.groupProduct = [
          {
            label: 'Tất cả',
            products: this.products
          }
        ]
        this.filterUser('')
        this.loadingProduct = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingProduct = false
      })
    },
    filterUser (query) {
      this.loadingUser = true
      UserApi.findSaleByName(query, this.company.id, 0, MAX_SALE_USER_NUMBER).then(res => {
        this.users = res.data.data.records.map(item => {
          return {'name': item.username, 'code': item.id}
        })

        this.filterData.pics = this.users
        this.groupUser = [
          {
            label: 'Tất cả',
            users: this.users
          }
        ]
        this.filter()
        this.loadingUser = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingUser = false
      })
    },
    hasEditPermission () {
      return Utils.isAdminUser(this.userInfo) || this.editPermission.includes(PERMISSION_KEY.ACCOUNTING)
    },
    buildFilterData () {
      const filterData = {
        order_id: this.orderId,
        type: this.filterData.type,
        status: this.filterData.payment_status.map(item => item.value),
        product_id_list: [],
        order: {
          payment_from_date: this.filterData.from_date,
          payment_to_date: this.filterData.to_date,
          data_status: [],
          data_source: [],
          pics: [],
          phone: this.filterData.phone,
          customer_name: this.filterData.customer_name,
          debt_status: null,
          charge_from_date: this.filterData.charge_date[0] ? this.filterData.charge_date[0] + '-01' : this.filterData.charge_date[0],
          charge_to_date: this.filterData.charge_date[1] ? this.filterData.charge_date[1] + '-01' : this.filterData.charge_date[1],
        }
      }
      if (filterData.type === null || filterData.type === '') {
        delete filterData['type']
      } else {
        filterData.type = filterData.type.value
      }
      if (filterData.order.phone === null || filterData.order.phone === '') {
        delete filterData.order['phone']
      }
      if (filterData.order.customer_name === null || filterData.order.customer_name === '') {
        delete filterData.order['customer_name']
      }
      if (this.filterData.statusDetail.length === 0) {
        filterData.order.data_status = this.filterData.status.map(item => {
          return {data_status_id: item.value, data_sub_status_id: null}
        })
      } else {
        filterData.order.data_status = this.filterData.statusDetail.map(item => {
          return {data_status_id: item.data_status, data_sub_status_id: item.value}
        })
      }
      if (this.filterData.data_channel.length === 0) {
        filterData.order.data_source = this.filterData.data_source.map(item => {
          return {data_source_id: item.value, data_channel_id: null}
        })
      } else {
        filterData.order.data_source = this.filterData.data_channel.map(item => {
          return {data_source_id: item.data_status, data_channel_id: item.value}
        })
      }
      if (this.filterData.pics.length > 0) {
        filterData.order.pics = this.filterData.pics.map(item => item.code)
      }
      // if (this.filterData.debt_status) {
      //   filterData.order.debt_status = this.filterData.debt_status.value
      // }
      if (this.filterData.products.length > 0) {
        filterData.product_id_list = this.filterData.products.map(item => item.code)
      }
      if (this.filterData.deletedProducts.length > 0) {
        filterData.product_id_list.push(...this.filterData.deletedProducts.map(item => item.code))
      }
      if (filterData.product_id_list.length === 0) {
        filterData.product_id_list = [0]
      }
      return filterData
    },
    filter () {
      if (this.loading) {
        return
      }
      this.loading = true
      PaymentApi.filter_detail(this.buildFilterData(), this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        this.items = res.data.data.records
        this.totalRow = res.data.data.total
        this.totalValue = res.data.data.sum_value
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    search () {
      this.filter()
    },
    edit (selectedRow) {
      this.items = this.items.map(item => {
        if (item.id === selectedRow.id) {
          item.editMode = true
        }
        return item
      })
    },
    save (selectedRow) {
      if (this.saving) {
        return
      }
      this.saving = true
      this.loading = true
      PaymentApi.update(selectedRow).then(res => {
        this.loading = false
        this.saving = false
        this.items = this.items.map(item => {
          item.editMode = false
          return item
        })
        Utils.successToast(this.$bvToast)
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    discard (selectedRow) {
      this.items = this.items.map(item => {
        item.editMode = false
        return item
      })
    },
    remove (id) {
      if (id) {
        this.$bvModal.msgBoxConfirm('Bạn có chắc không?', {
          title: false,
          buttonSize: 'sm',
          centered: true,
          size: 'sm',
          footerClass: 'p-2'
        }).then(res => {
          if (res) {
            PaymentApi.remove(id).then(res => {
              Utils.successToast(this.$bvToast)
              this.filter()
              this.$bvModal.hide('listSelectProductModal' + this.type)
            }).catch(err => {
              Utils.handleError(this.$bvToast, err)
            })
          }
        })
      }
    },
    getDebtStatusString (debt_status) {
      if (debt_status) {
        return DEBT_STATUS_LIST.find(item => item.value === debt_status).text
      }
      return ''
    },
    toggleColumnSearchForm (event, key) {
      this.configSearchItems = this.configSearchItems.map(field => {
        if (field.key === key) {
          return {...field, show: event}
        }
        return field
      })

      localStorage.setItem(LOCAL_STORAGE_KEY.ACCOUNTING_SEARCH_ITEMS, JSON.stringify(this.configSearchItems))
    },
    onDoubleClicked (item) {
      this.selectedId = item.payment.order.id
      this.$bvModal.show('orderDetailModal')
    },
    hideModal (modalId) {
      this.$bvModal.hide(modalId)
    },
    showApproveModal (item) {
      this.selectedPaymentId = item.id
      this.$bvModal.show('approveModal')
    },
    showDispproveModal (item) {
      this.selectedPaymentId = item.id
      this.$bvModal.show('disapproveModal')
    },
    showCancelApprovedModal (item) {
      this.selectedPaymentId = item.id
      this.$bvModal.show('cancelApprovedModal')
    },
    approve () {
      if (this.selectedPaymentId) {
        PaymentApi.approve({id: this.selectedPaymentId, accountant_note: this.approveText}).then(res => {
          Utils.successToast(this.$bvToast)
          this.filter()
          this.$bvModal.hide('approveModal')
        }).catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
      }
    },
    cancelApproved () {
      if (this.selectedPaymentId) {
        PaymentApi.cancelApproved({id: this.selectedPaymentId, accountant_note: this.approveText}).then(res => {
          Utils.successToast(this.$bvToast)
          this.filter()
          this.$bvModal.hide('cancelApprovedModal')
        }).catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
      }
    },
    disapprove () {
      if (this.selectedPaymentId) {
        PaymentApi.disapprove({id: this.selectedPaymentId, accountant_note: this.disapproveText}).then(res => {
          Utils.successToast(this.$bvToast)
          this.filter()
          this.$bvModal.hide('disapproveModal')
        }).catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
      }
    },
    hideApproveModal () {
      this.filter()
      this.approveText = ''
      this.disapproveText = ''
      this.selectedPaymentId = null
    },
    hideCancelApprovedModal () {
      this.filter()
      this.approveText = ''
      this.disapproveText = ''
      this.cancelApprovedText = ''
      this.selectedPaymentId = null
    },
    onSelectStatus (event, status) {
      if (this.statusDetailList.length === 0) {
        this.statusDetailList.push(...event.details)
      } else {
        this.statusDetailList = []
      }
    },
    onRemoveStatus (event, status) {
      if (this.filterData.status.length === 2) {
        const lastStatus = this.filterData.status.filter(item => item.value !== event.value)
        this.statusDetailList.push(...lastStatus[0].details)
      }
    },
    onSelectSource (event, source) {
      if (this.data_channel.length === 0) {
        this.data_channel.push(...event.details)
      } else {
        this.data_channel = []
      }
    },
    onRemoveSource (event, source) {
      if (this.filterData.data_source.length === 2) {
        const lastItems = this.filterData.data_source.filter(item => item.value !== event.value)
        this.data_channel.push(...lastItems[0].details)
      }
    },
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/accounting/AccountingDetailList.vue